export default () => ({
  selected: null,
  sizeTitle: null,
  sizes: null,
  isOverlay: false,
  display: false,
  showHeading: false,
  customerId: null,

  initSizes(title, customerId, isOverlay) {
    this.isOverlay = isOverlay;
    this.customerId = customerId;
    CF.customerReady(
      function () {
        const lowerCaseTitle = title.toLowerCase();
        this.sizeTitle = `preference_size_${lowerCaseTitle}`;
        this.sizes = CF.customer.get(`${this.sizeTitle}`) || [];
        if (this.sizes.length > 0 && this.isOverlay) {
          this.display = false;
        } else {
          this.display = true;
        }
      }.bind(this)
    );
  },

  setInitialSelectedValue(value, target) {
    CF.customerReady(
      function () {
        target.checked = this.sizes.includes(value);
      }.bind(this)
    );
  },

  setSelectedValue(value, checked) {
    if (!checked) {
      this.sizes.splice(this.sizes.indexOf(value), 1);
    } else {
      this.sizes.push(value);
    }

    const event = new CustomEvent("sizes-updated", {
      detail: {
        sizeTitle: this.sizeTitle,
        sizes: this.sizes,
        customerId: this.customerId,
      },
    });
    document.dispatchEvent(event);
  },

  setDisplay() {
    //Todo: rewrite this to be more dynamic
    CF.customerReady(
      function () {
        const tops = CF.customer.get("preference_size_tops");
        const bottoms = CF.customer.get("preference_size_bottoms");
        const shoes = CF.customer.get("preference_size_shoes");
        const tailoring = CF.customer.get("preference_size_tailoring");

        if (
          tops &&
          tops.length > 0 &&
          bottoms &&
          bottoms.length > 0 &&
          shoes &&
          shoes.length > 0 &&
          tailoring &&
          tailoring.length > 0
        ) {
          this.showHeading = false;
        } else {
          this.showHeading = true;
        }
      }.bind(this)
    );
  },
});
